$(function() {
    var spinnerExt = $.nette.ext('spinner');

    if (! spinnerExt) {
        return true;
    }

    $('.js-form-submit-spinner').on('submit', function() {
        var $form = $(this);
        var $btn = $form.find('.js-form-submit-spinner-btn');

        if ($form.find('.pdforms-error').length) {
            return
        }

        var $placeholder = spinnerExt.getElementPlaceholder($btn),
            $holder = $('<span class="ajax-btn-holder"></span>'),
            $overlay = $('<span class="ajax-overlay"></span>'),
            $spinner = $('<span class="ajax-loader"></span>'),
            $message = $('<span class="ajax-message"></span>'),
            text = $btn.data('spinner-message');

        $message.text(text);

        $holder.append($overlay);
        $holder.append($spinner);
        $holder.append($message);

        $placeholder.append($holder);
    });
});
